import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import Header from "@/components/Header";
import NotFound from "@/components/NotFound";

const DownloadAppBanner = lazy(() => import("@/components/DownloadAppBanner"));

export const Route = createFileRoute("/_videoPlayer")({
  component: RouteComponent,
  notFoundComponent: NotFound,
});

function RouteComponent() {
  return (
    <div className="relative grid h-dvh w-full max-w-screen grid-rows-[1fr_auto] overflow-hidden lg:grid-rows-[auto_1fr_auto]">
      <Header className="hidden lg:flex" />
      <Outlet />
      <Suspense fallback={null}>
        <DownloadAppBanner className="block p-3 lg:hidden" />
      </Suspense>
    </div>
  );
}
